import React, { Fragment } from 'react';
import { IntlProvider } from 'react-intl';
import { useAsync } from 'react-use';
import { listFormatDataByCode, pluralRulesDataByCode } from './localeData';
const importTranslations = locale => {
  const promise = locale === 'en' ? import( /* webpackChunkName: 'translations-en' */ /* webpackMode: "eager" */'../../locales/messages_en.json') : import( /* webpackChunkName: 'translations-[request]' */`../../locales/messages_${locale}.json`);
  return promise.then(module => module.default, () => {});
};
export const WithTranslations = _ref => {
  let {
    locale,
    children
  } = _ref;
  const {
    loading: isTranslationsLoading,
    value: translations
  } = useAsync(() => Promise.all([importTranslations(locale), importTranslations('en')]).then(_ref2 => {
    let [currentTranslation, enTranslation] = _ref2;
    return {
      ...enTranslation,
      ...currentTranslation
    };
  }));
  const {
    loading: isLocaleDataLoading
  } = useAsync(() => {
    var _pluralRulesDataByCod, _listFormatDataByCode;
    return Promise.all([(_pluralRulesDataByCod = pluralRulesDataByCode[locale]) == null ? void 0 : _pluralRulesDataByCod.call(pluralRulesDataByCode), (_listFormatDataByCode = listFormatDataByCode[locale]) == null ? void 0 : _listFormatDataByCode.call(listFormatDataByCode)]);
  });
  const isLoading = isLocaleDataLoading && isTranslationsLoading;
  return /*#__PURE__*/React.createElement(IntlProvider, {
    messages: translations,
    locale: locale,
    textComponent: Fragment
  }, children(isLoading));
};
//# sourceMappingURL=WithTranslations.js.map